/**
 * Links and buttons don't 'work' properly in Sitecore's Experience
 * Editor because it supresses `onClick` events so that authors can
 * click-to-edit links/buttons without activating them.
 *
 * We can get around this by utilising another (similar) event handler,
 * `onMouseDown`, as well as taking some additional measures to bring
 * things like keyboard accessibility back on parity with `onClick`.
 *
 * Note this is intended for use within the likes of `ExperienceEditorContent`
 * and thus doesn't have `ExperienceEditorContext` checks of its own.
 */

import React from 'react';
import { StyledComponent } from 'styled-components';

import { bindKeyboardControls } from 'core/utils/accessibility-utils';
import * as GS from 'core/styles/Containers';

interface IProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	StyledComponent?: StyledComponent<'button', any, {}, never>;
	callback: (
		event:
			| React.MouseEvent<HTMLButtonElement, MouseEvent>
			| React.KeyboardEvent<HTMLElement>,
	) => void;
	children: React.ReactNode;
}

const ExperienceEditorButton = ({
	StyledComponent = GS.EECtaWrapper,
	callback,
	children,
	...props
}: IProps) => (
	<StyledComponent
		onMouseDown={callback}
		onKeyUp={e => bindKeyboardControls(e, callback)}
		{...props}
	>
		{children}
	</StyledComponent>
);

export default ExperienceEditorButton;
